import { render, staticRenderFns } from "./PgaValutazioneOffertaTotaliOffertaValutazione.vue?vue&type=template&id=6e430fe4&"
import script from "./PgaValutazioneOffertaTotaliOffertaValutazione.vue?vue&type=script&lang=ts&"
export * from "./PgaValutazioneOffertaTotaliOffertaValutazione.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e430fe4')) {
      api.createRecord('6e430fe4', component.options)
    } else {
      api.reload('6e430fe4', component.options)
    }
    module.hot.accept("./PgaValutazioneOffertaTotaliOffertaValutazione.vue?vue&type=template&id=6e430fe4&", function () {
      api.rerender('6e430fe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/ValutazioneOfferta/Components/PgaValutazioneOffertaTotaliOffertaValutazione.vue"
export default component.exports